import { Children, isValidElement, ReactElement, ReactNode, useCallback, useMemo } from 'react'

import { DrawerHeader } from '../DrawerHeader'
import { DrawerStep, DrawerStepProps } from '../DrawerStep'

export interface DrawerStepsProps {
  activeStep: number
  children?: ReactNode
  closable?: boolean
  labelId?: string
  onBack?: () => void
  onStepChange: (step: number) => void
}

export const DrawerSteps = ({ activeStep, children, closable, labelId, onBack, onStepChange }: DrawerStepsProps) => {
  const steps = useMemo(
    () =>
      Children.toArray(children).filter(
        (child): child is ReactElement<DrawerStepProps> => isValidElement(child) && child.type === DrawerStep,
      ),
    [children],
  )

  const currentStep = steps[activeStep]

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack()
    } else {
      onStepChange(activeStep - 1)
    }
  }, [activeStep, onBack, onStepChange])

  if (!currentStep) {
    return null
  }

  const { children: stepContent, icon, title, actions, onAction, customContent } = currentStep.props

  return (
    <>
      <DrawerHeader
        actions={actions}
        closable={closable}
        customContent={customContent}
        icon={icon}
        labelId={labelId}
        onAction={onAction}
        onBack={activeStep > 0 ? handleBack : undefined}
        title={title}
      />
      {stepContent}
    </>
  )
}
